import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import {
  Card,
  Dialog
} from '@material-ui/core';
import {
  getUserCreditCardsApi,
  deleteUserCreditCardApi
} from 'api';
import { ConfirmDialog, BackdropCircular } from 'components';
import CreditCard from './CreditCard';
import CreditCardForm from './CreditCardForm';


const DialogCard = withStyles({
  root: {
    '& .MuiDialog-paper': {
      backgroundColor: 'transparent',
      boxShadow: 'none'
    },
    '& .card-container': {
      color: '#3C4257',
      background: '#fff',
      borderRadius: '15px',
      marginTop: '130px',
      boxShadow: `0px 10px 13px -6px rgb(0 0 0 / 6%),
                   0px 20px 31px 3px rgb(0 0 0 / 4%),
                   0px 8px 38px 7px rgb(0 0 0 / 4%)`
    },
    '& form': {
      margin: '5% auto',
      padding: '0 10px'
    },
    '& .rccs': {
      position: 'absolute',
      top: '0',
      left: '50%',
      transform: 'translate(-50%, 0)'
    }
  }
})(Dialog);

const UserCreditCards = () => {
  const dispatch = useDispatch();
  const [creditCardData, setCreditCardData] = useState({master_id: null, action: null});
  const { userCreditCards = [], loadingUserCreditCards } = useSelector((state: IReduxState) => state.user);

  useEffect(() => {
    getUserCreditCardsApi({dispatch});
  }, [creditCardData.master_id]);

  return (
    <div className="px-4">
      <Card className="p-7 flex flex-wrap">
        {!!userCreditCards.length && userCreditCards.map((card, index) => (
          <CreditCard
            key={`card-${index}`}
            card={card}
            setCreditCardData={setCreditCardData}
          />
        ))}
      </Card>
      <DialogCard
        open={creditCardData?.action === 'replace'}
        fullScreen
      >
        <CreditCardForm
          creditCardData={creditCardData}
          setCreditCardData={setCreditCardData}
        />
      </DialogCard>
      <ConfirmDialog
        title="Do you want to delete payment card from your account?"
        open={creditCardData.action === 'delete'}
        setOpen={() => setCreditCardData({master_id: '', action: ''})}
        onConfirm={async () => {
          await deleteUserCreditCardApi({dispatch, masterId: creditCardData.master_id});
          setCreditCardData({master_id: '', action: ''});
        }}
      >
        You can delete a card, only when you have no subscriptions associated with it.
      </ConfirmDialog>
      <BackdropCircular loading={loadingUserCreditCards} />
    </div>
  );
};

export default UserCreditCards;
